// @ts-nocheck
/* eslint-disable no-alert, no-console, react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  Building2, 
  ChevronRight, 
  ChevronLeft,
  FileText, 
  Search, 
  ArrowLeft, 
  CheckSquare, 
  Square, 
  Send, 
  Lock, 
  CheckCircle, 
  Clock, 
  Receipt,
  Loader2,
  FileCheck,
  AlertCircle,
  PieChart
} from "lucide-react";
import { collection, query, onSnapshot, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions"; 
import { db } from "../../config/firebase";

const AdminFaturamentoPage = () => {
  const [garantias, setGarantias] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  
  const [selectedCompany, setSelectedCompany] = useState(/** @type {string | null} */ (null));
  const [selectedLocatarios, setSelectedLocatarios] = useState(/** @type {string[]} */ ([]));
  const [isProcessingNF, setIsProcessingNF] = useState(false);

  // 🟢 Paginação: Tela 1 (Tabela de Imobiliárias)
  const [currentPageImob, setCurrentPageImob] = useState(1);
  const [itemsPerPageImob, setItemsPerPageImob] = useState(20);

  // 🟢 Paginação: Tela 2 (Tabela de Locatários)
  const [currentPageLoc, setCurrentPageLoc] = useState(1);
  const [itemsPerPageLoc, setItemsPerPageLoc] = useState(20);

  useEffect(() => {
    const q = query(collection(db, "contratos_ativos"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const garantiasData = /** @type {any[]} */ ([]);
      snapshot.forEach((docSnap) => {
        garantiasData.push({ id: docSnap.id, ...docSnap.data() });
      });
      setGarantias(garantiasData);
      setLoading(false);
    }, (error) => {
      console.error("Erro ao buscar garantias para faturamento:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Reseta as páginas ao pesquisar
  useEffect(() => {
    setCurrentPageImob(1);
    setCurrentPageLoc(1);
  }, [searchTerm]);

  const getAgrupamentoImobiliarias = () => {
    const agrupado = garantias.reduce((acc, curr) => {
      const compName = curr.companyName || "Desconhecida";
      const status = curr.ciclo?.statusRepasse || "Não Definido";
      
      if (!acc[compName]) {
        acc[compName] = {
          nome: compName,
          totalContratos: 0,
          prontosParaNF: 0,      
          bloqueadosPagamento: 0, 
          nfEmitida: 0,          
          errosNF: 0             
        };
      }
      
      acc[compName].totalContratos += 1;
      
      if (status === "Repasse Pago" || status === "Erro na NF") acc[compName].prontosParaNF += 1;
      if (status === "Aguardando Fechamento" || status === "Repasse Cobrado") acc[compName].bloqueadosPagamento += 1;
      if (status === "NF Emitida") acc[compName].nfEmitida += 1;
      if (status === "Erro na NF") acc[compName].errosNF += 1;

      return acc;
    }, {});

    return Object.values(agrupado)
      .filter(imob => imob.nome.toLowerCase().includes(searchTerm.toLowerCase()))
      .sort((a, b) => b.prontosParaNF - a.prontosParaNF);
  };

  const listaImobiliarias = getAgrupamentoImobiliarias();

  // Fatiamento Paginação Tela 1
  const indexOfLastImob = currentPageImob * itemsPerPageImob;
  const indexOfFirstImob = indexOfLastImob - itemsPerPageImob;
  const currentImobs = listaImobiliarias.slice(indexOfFirstImob, indexOfLastImob);
  const totalPagesImob = Math.ceil(listaImobiliarias.length / itemsPerPageImob);

  const nextPageImob = () => { if (currentPageImob < totalPagesImob) setCurrentPageImob(prev => prev + 1); };
  const prevPageImob = () => { if (currentPageImob > 1) setCurrentPageImob(prev => prev - 1); };

  const contratosDaEmpresa = selectedCompany 
    ? garantias.filter(g => g.companyName === selectedCompany) 
    : [];

  // Fatiamento Paginação Tela 2
  const indexOfLastLoc = currentPageLoc * itemsPerPageLoc;
  const indexOfFirstLoc = indexOfLastLoc - itemsPerPageLoc;
  const currentLocs = contratosDaEmpresa.slice(indexOfFirstLoc, indexOfLastLoc);
  const totalPagesLoc = Math.ceil(contratosDaEmpresa.length / itemsPerPageLoc);

  const nextPageLoc = () => { if (currentPageLoc < totalPagesLoc) setCurrentPageLoc(prev => prev + 1); };
  const prevPageLoc = () => { if (currentPageLoc > 1) setCurrentPageLoc(prev => prev - 1); };

  const locatariosProntosParaNF = contratosDaEmpresa.filter(
    c => c.ciclo?.statusRepasse === "Repasse Pago" || c.ciclo?.statusRepasse === "Erro na NF"
  );
  const isAllSelected = locatariosProntosParaNF.length > 0 && selectedLocatarios.length === locatariosProntosParaNF.length;

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedLocatarios([]);
    } else {
      setSelectedLocatarios(locatariosProntosParaNF.map(c => c.id));
    }
  };

  const handleToggleSelectLocatario = (id) => {
    setSelectedLocatarios(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const voltarParaImobiliarias = () => {
    setSelectedCompany(null);
    setSelectedLocatarios([]); 
    setSearchTerm("");
    setCurrentPageLoc(1);
  };

  const getCurrentEnv = () => {
    const currentDomain = window.location.hostname;
    return process.env.REACT_APP_ENV || (currentDomain.includes('homolog') || currentDomain.includes('localhost') ? 'homolog' : 'production');
  };

  const handleEmitirNFsEmLote = async () => {
    if (selectedLocatarios.length === 0) return;

    const confirmar = window.confirm(`Deseja processar a emissão de ${selectedLocatarios.length} Nota(s) Fiscal(is) via Asaas?`);
    if (!confirmar) return;

    setIsProcessingNF(true);
    const activeEnv = getCurrentEnv();
    
    const functions = getFunctions();
    const issueLocatarioInvoice = httpsCallable(functions, 'issueLocatarioInvoice');
    const createAsaasLocatario = httpsCallable(functions, 'createAsaasLocatario');

    let sucessos = 0;
    let erros = 0;

    try {
      for (const contratoId of selectedLocatarios) {
        const contrato = contratosDaEmpresa.find(c => c.id === contratoId);
        const ref = doc(db, "contratos_ativos", contratoId);
        
        try {
          let asaasCustomerId = contrato.pagador?.asaasCustomerId;
          
          if (!asaasCustomerId) {
            console.log(`Criando locatário B2C no Asaas para o protocolo ${contrato.protocoloOrigem}...`);
            const cpfCnpjPagador = contrato.pagador?.cpf || contrato.pagador?.cnpj;
            
            if (!cpfCnpjPagador) {
              throw new Error("O Locatário não possui um CPF/CNPJ registrado no banco de dados.");
            }

            const locatarioData = contrato.pagador || {};
            const imovelData = contrato.imovel || contrato.endereco || {};

            const cep = locatarioData.cep || imovelData.cep || "88110-450";
            const address = locatarioData.logradouro || locatarioData.endereco || imovelData.logradouro || imovelData.endereco || "Avenida Brasília";
            const addressNumber = locatarioData.numero || imovelData.numero || "295";
            const province = locatarioData.bairro || imovelData.bairro || "Bela Vista";

            const customerPayload = {
              environment: activeEnv, 
              customerData: {
                name: locatarioData.nome || "Locatário",
                cpfCnpj: cpfCnpjPagador,
                email: locatarioData.email || "financeiro@realbeneficios.com.br", 
                externalReference: contrato.id,
                postalCode: cep, 
                address: address,
                addressNumber: addressNumber,
                province: province
              }
            };

            const responseCustomer = await createAsaasLocatario(customerPayload);
            const customerData = responseCustomer.data;
            asaasCustomerId = customerData.asaasCustomerId;

            await setDoc(ref, {
              pagador: { asaasCustomerId: asaasCustomerId }
            }, { merge: true });
          }

          const rawValor = String(contrato.faturamento?.valorTaxa || "0").replace(/\./g, '').replace(',', '.');
          const valorTaxa = parseFloat(rawValor || "0");

          const payloadNF = {
            companyId: contrato.companyId, 
            environment: activeEnv, 
            invoiceData: {
              customer: asaasCustomerId,
              value: valorTaxa,
              serviceDescription: `Prestação de serviços de garantia locatícia referente ao Protocolo: ${contrato.protocoloOrigem}`,
              effectiveDate: new Date().toISOString().split('T')[0],
              externalReference: contrato.id,
              municipalServiceExternalId: "15.10.01", 
              municipalServiceDescription: "Serviços de cobrança e garantia locatícia", 
              name: "Serviços de Garantia Locatícia",
              taxes: {
                retainIss: false,
                iss: 5, 
                pis: 0, 
                cofins: 0,
                csll: 0,
                inss: 0,
                ir: 0
              }
            }
          };

          const responseNF = await issueLocatarioInvoice(payloadNF);
          const nfData = responseNF.data;
          const invoiceId = nfData.invoice.id;

          await setDoc(ref, {
            ciclo: {
              statusRepasse: "NF Emitida",
              dataEmissaoNF: serverTimestamp(),
              idNotaFiscalAsaas: invoiceId,
              motivoErroNF: null
            }
          }, { merge: true });
          sucessos++;

        } catch (nfError) {
          const errorMsg = /** @type {any} */ (nfError).message;
          console.error(`Falha ao emitir NF para o contrato ${contrato.protocoloOrigem}:`, nfError);
          await setDoc(ref, {
            ciclo: {
              statusRepasse: "Erro na NF",
              motivoErroNF: errorMsg || "Erro de comunicação com o serviço fiscal."
            }
          }, { merge: true });
          erros++;
        }
      }
      
      alert(`Processamento em Lote Concluído!\n✅ Emitidas com Sucesso: ${sucessos}\n❌ Falhas Retidas: ${erros}`);
      setSelectedLocatarios([]);
    } catch (err) {
      console.error("Erro fatal no loop de emissão:", err);
      alert("Ocorreu um erro crítico durante o lote. Algumas NFs podem não ter sido processadas.");
    } finally {
      setIsProcessingNF(false);
    }
  };

  if (loading) {
    return (
      <div className="p-4 sm:p-5 xl:p-8 w-full animate-pulse bg-slate-50 min-h-screen">
        <div className="h-8 bg-slate-200 rounded w-64 mb-2"></div>
        <div className="h-4 bg-slate-200 rounded w-96 mb-8"></div>
        
        <div className="bg-white rounded-2xl border border-slate-200 h-16 w-full mb-6 flex items-center px-4">
           <div className="h-8 bg-slate-200 rounded w-full md:w-96"></div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 border-b border-slate-200 h-14"></div>
          {Array(6).fill(0).map((_, i) => (
            <div key={i} className="flex justify-between items-center p-4 border-b border-slate-100">
              <div className="flex items-center gap-3">
                 <div className="w-10 h-10 bg-slate-200 rounded-xl shrink-0"></div>
                 <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-48"></div><div className="h-3 bg-slate-100 rounded w-24"></div></div>
              </div>
              <div className="hidden md:block space-y-2"><div className="h-4 bg-slate-200 rounded w-24"></div></div>
              <div className="hidden lg:block h-6 bg-slate-200 rounded-full w-24"></div>
              <div className="h-8 bg-slate-200 rounded w-28"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-5 xl:p-8 w-full font-sans animate-fade-in bg-slate-50 min-h-full">
      
      <div className="mb-6 xl:mb-8">
        <div className="flex items-center text-sm text-slate-500 font-medium mb-1">
          <Link to="/super-admin" className="hover:text-brand-primary transition-colors">Dashboard</Link>
          <ChevronRight className="w-4 h-4 mx-1" />
          <span className={!selectedCompany ? "text-slate-800 font-semibold" : "cursor-pointer hover:text-brand-primary"} onClick={voltarParaImobiliarias}>
            Faturamento (Notas Fiscais)
          </span>
          {selectedCompany && (
            <>
              <ChevronRight className="w-4 h-4 mx-1" />
              <span className="text-slate-800 font-semibold truncate max-w-[200px]">{selectedCompany}</span>
            </>
          )}
        </div>
        <h1 className="text-2xl xl:text-3xl font-bold text-slate-800 flex items-center gap-2">
          <FileText className="w-7 h-7 text-brand-primary" />
          Emissão de Notas Fiscais (B2C)
        </h1>
        <p className="text-slate-500 text-sm mt-1">
          {selectedCompany 
            ? `Selecione os inquilinos da ${selectedCompany} para disparo em lote.` 
            : "Gerencie as obrigações tributárias dos inquilinos por imobiliária."}
        </p>
      </div>

      {/* TELA PRINCIPAL: TABELA DE IMOBILIÁRIAS (SUBSTITUINDO OS CARDS) */}
      {!selectedCompany && (
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden flex flex-col min-h-[400px]">
          
          {/* BARRA DE PESQUISA SUPERIOR */}
          <div className="p-4 xl:p-5 border-b border-slate-200 bg-slate-50 flex flex-col md:flex-row justify-between items-center shrink-0">
            <div className="relative w-full md:max-w-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="w-4 h-4 text-slate-400" />
              </div>
              <input 
                type="text"
                placeholder="Buscar imobiliária..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-4 py-2 xl:py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary transition-shadow shadow-sm"
              />
            </div>
          </div>

          <div className="overflow-x-auto custom-scrollbar flex-1">
            <table className="w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-white border-b border-slate-200 text-slate-500 font-semibold">
                <tr>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Imobiliária</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Contratos Totais</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Status de Faturamento (Locatários)</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4 text-right">Ação</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {currentImobs.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-6 py-12 text-center text-slate-500 bg-slate-50/50">
                      <div className="flex flex-col items-center justify-center">
                        <Building2 className="w-10 h-10 text-slate-300 mb-3" />
                        <p className="font-bold text-slate-700 text-base">Nenhuma imobiliária encontrada.</p>
                        <p className="text-sm mt-1">Nenhum registro corresponde à sua busca.</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentImobs.map((imob) => (
                    <tr key={imob.nome} className={`transition-colors hover:bg-slate-50 group ${imob.errosNF > 0 ? 'bg-red-50/20' : ''}`}>
                      <td className="px-4 py-3 xl:px-6 xl:py-4">
                        <div className="flex items-center gap-3">
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 border ${imob.errosNF > 0 ? 'bg-red-50 border-red-100' : 'bg-slate-50 border-slate-200'}`}>
                            <Building2 className={`w-5 h-5 ${imob.errosNF > 0 ? 'text-red-400' : 'text-slate-400 group-hover:text-brand-primary'}`} />
                          </div>
                          <div>
                            <p className="font-bold text-slate-800 text-[13px] xl:text-sm max-w-[200px] xl:max-w-[300px] truncate" title={imob.nome}>
                              {imob.nome}
                            </p>
                          </div>
                        </div>
                      </td>
                      
                      <td className="px-4 py-3 xl:px-6 xl:py-4">
                        <span className="font-bold text-slate-700">{imob.totalContratos}</span>
                        <span className="text-slate-400 ml-1 text-xs">ativos</span>
                      </td>

                      <td className="px-4 py-3 xl:px-6 xl:py-4">
                        <div className="flex items-center gap-2 flex-wrap">
                          {imob.prontosParaNF > 0 && (
                            <span className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 border border-green-200 px-2.5 py-1 rounded-md text-xs font-semibold" title="Prontos para emitir NF">
                              <CheckCircle className="w-3.5 h-3.5" /> {imob.prontosParaNF} Liberados
                            </span>
                          )}
                          {imob.errosNF > 0 && (
                            <span className="inline-flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 px-2.5 py-1 rounded-md text-xs font-bold animate-pulse" title="Falhas na emissão">
                              <AlertCircle className="w-3.5 h-3.5" /> {imob.errosNF} Erros
                            </span>
                          )}
                          {imob.bloqueadosPagamento > 0 && (
                            <span className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-md text-xs font-semibold" title="Aguardando a imobiliária pagar o repasse B2B">
                              <Lock className="w-3.5 h-3.5" /> {imob.bloqueadosPagamento} Bloqueados
                            </span>
                          )}
                          {imob.nfEmitida > 0 && (
                            <span className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-700 border border-blue-200 px-2.5 py-1 rounded-md text-xs font-semibold" title="NFs já emitidas este mês">
                              <FileCheck className="w-3.5 h-3.5" /> {imob.nfEmitida} Concluídos
                            </span>
                          )}
                          {/* Se todos forem 0, mostra um placeholder */}
                          {imob.prontosParaNF === 0 && imob.errosNF === 0 && imob.bloqueadosPagamento === 0 && imob.nfEmitida === 0 && (
                            <span className="text-slate-400 text-xs italic">Sem dados de faturamento</span>
                          )}
                        </div>
                      </td>

                      <td className="px-4 py-3 xl:px-6 xl:py-4 text-right">
                        <button 
                          onClick={() => setSelectedCompany(imob.nome)}
                          className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl transition-all text-xs xl:text-sm font-bold shadow-sm ${
                            imob.errosNF > 0 
                              ? "bg-red-50 text-red-700 hover:bg-red-600 hover:text-white border border-red-200" 
                              : "bg-white text-slate-600 hover:bg-brand-primary hover:text-white border border-slate-200 hover:border-brand-primary"
                          }`}
                        >
                          {imob.errosNF > 0 ? "Revisar Falhas" : "Ver Locatários"} 
                          <ChevronRight className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* 🟢 CONTROLES DE PAGINAÇÃO DA TABELA PRINCIPAL */}
          {listaImobiliarias.length > 0 && (
            <div className="p-4 sm:p-5 border-t border-slate-200 bg-white flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500 shrink-0">
              <span className="font-medium text-center sm:text-left">
                Mostrando <strong className="text-slate-800">{indexOfFirstImob + 1}</strong> a <strong className="text-slate-800">{Math.min(indexOfLastImob, listaImobiliarias.length)}</strong> de <strong className="text-slate-800">{listaImobiliarias.length}</strong> imobiliárias
              </span>
              <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto justify-center">
                
                <div className="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
                  <span className="font-medium">Itens por página:</span>
                  <select 
                    value={itemsPerPageImob}
                    onChange={(e) => setItemsPerPageImob(Number(e.target.value))}
                    className="bg-transparent border-none font-bold text-brand-primary focus:ring-0 cursor-pointer text-sm outline-none"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>

                {totalPagesImob > 1 && (
                  <div className="flex items-center gap-2">
                    <button onClick={prevPageImob} disabled={currentPageImob === 1} className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 transition-colors shadow-sm">
                      <ChevronLeft className="w-4 h-4" />
                    </button>
                    <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                      {currentPageImob} / {totalPagesImob}
                    </span>
                    <button onClick={nextPageImob} disabled={currentPageImob >= totalPagesImob} className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 transition-colors shadow-sm">
                      <ChevronRight className="w-4 h-4" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {/* TELA SECUNDÁRIA: TABELA DE LOCATÁRIOS */}
      {selectedCompany && (
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
          <div className="p-4 xl:p-6 border-b border-slate-200 bg-slate-50 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <button 
              onClick={voltarParaImobiliarias}
              className="flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-brand-primary transition-colors bg-white px-3 py-2 rounded-lg border border-slate-200 shadow-sm shrink-0"
            >
              <ArrowLeft className="w-4 h-4" /> Voltar
            </button>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full lg:w-auto justify-end">
              <div className="text-sm font-medium text-slate-500 whitespace-nowrap bg-white px-3 py-2 rounded-lg border border-slate-200 shadow-sm">
                <span className="font-bold text-brand-primary">{selectedLocatarios.length}</span> selecionado(s)
              </div>
              
              <button 
                onClick={handleEmitirNFsEmLote}
                disabled={selectedLocatarios.length === 0 || isProcessingNF}
                className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 bg-brand-primary text-white hover:bg-teal-600 rounded-xl transition-colors font-bold text-sm shadow-md disabled:opacity-50"
              >
                {isProcessingNF ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                Emitir NFs em Lote
              </button>
            </div>
          </div>

          <div className="overflow-x-auto custom-scrollbar min-h-[300px]">
            <table className="w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-white border-b border-slate-200 text-slate-500 font-semibold">
                <tr>
                  <th className="px-4 py-3 xl:px-6 xl:py-4 w-12">
                    <button 
                      onClick={handleToggleSelectAll}
                      disabled={locatariosProntosParaNF.length === 0}
                      className="text-slate-400 hover:text-brand-primary transition-colors disabled:opacity-50"
                      title="Selecionar todos os liberados"
                    >
                      {isAllSelected && locatariosProntosParaNF.length > 0 ? <CheckSquare className="w-5 h-5 text-brand-primary" /> : <Square className="w-5 h-5" />}
                    </button>
                  </th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Protocolo</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Locatário Pagador</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Valor da Taxa</th>
                  <th className="px-4 py-3 xl:px-6 xl:py-4">Status da Emissão</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {currentLocs.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="px-6 py-10 text-center text-slate-500">
                      Nenhum locatário nesta página.
                    </td>
                  </tr>
                ) : (
                  currentLocs.map((contrato) => {
                    
                    const isLiberadoParaNF = contrato.ciclo?.statusRepasse === "Repasse Pago";
                    const isErroNF = contrato.ciclo?.statusRepasse === "Erro na NF";
                    const isEmitido = contrato.ciclo?.statusRepasse === "NF Emitida";
                    const isSelected = selectedLocatarios.includes(contrato.id);
                    
                    const canSelect = isLiberadoParaNF || isErroNF;
                    
                    return (
                      <tr 
                        key={contrato.id} 
                        className={`transition-colors ${isSelected ? 'bg-teal-50/50' : 'hover:bg-slate-50'} ${!canSelect && !isEmitido ? 'opacity-70 bg-slate-50/50' : ''}`}
                      >
                        <td className="px-4 py-3 xl:px-6 xl:py-4">
                          {canSelect ? (
                            <button 
                              onClick={() => handleToggleSelectLocatario(contrato.id)}
                              className="text-slate-400 hover:text-brand-primary transition-colors"
                            >
                              {isSelected ? <CheckSquare className="w-5 h-5 text-brand-primary" /> : <Square className="w-5 h-5" />}
                            </button>
                          ) : isEmitido ? (
                            <span title="NF já foi emitida">
                              <CheckCircle className="w-5 h-5 text-blue-500" />
                            </span>
                          ) : (
                            <span title="Bloqueado: Imobiliária ainda não pagou">
                              <Lock className="w-5 h-5 text-slate-300" />
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-3 xl:px-6 xl:py-4 font-bold text-slate-800">
                          {contrato.protocoloOrigem}
                        </td>
                        <td className="px-4 py-3 xl:px-6 xl:py-4">
                          <p className="font-semibold text-slate-800">{contrato.pagador?.nome || "Não informado"}</p>
                          <p className="text-xs text-slate-500">CPF: {contrato.pagador?.cpf || "N/A"}</p>
                        </td>
                        <td className="px-4 py-3 xl:px-6 xl:py-4">
                          <div className="flex flex-col gap-1.5">
                            <span className="font-bold text-slate-800">R$ {contrato.faturamento?.valorTaxa || "0,00"}</span>
                            {(contrato.faturamento?.isProRata || contrato.faturamento?.diasProRata) && (
                              <span className="inline-flex items-center gap-1 bg-indigo-50 text-indigo-700 border border-indigo-200 px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider w-max" title={`Cobrança proporcional a ${contrato.faturamento?.diasProRata || 'X'} dias`}>
                                <PieChart className="w-3 h-3" />
                                Pró-Rata {contrato.faturamento?.diasProRata ? `(${contrato.faturamento.diasProRata}d)` : ""}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-3 xl:px-6 xl:py-4">
                          {isLiberadoParaNF && (
                            <div className="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1 rounded-lg border border-green-200 font-semibold text-xs w-max">
                              <CheckCircle className="w-3.5 h-3.5" /> Liberado p/ Emissão
                            </div>
                          )}
                          
                          {isErroNF && (
                            <div className="flex items-center gap-1.5 text-red-700 bg-red-50 px-2.5 py-1 rounded-lg border border-red-200 font-bold text-xs w-max" title={contrato.ciclo?.motivoErroNF}>
                              <AlertCircle className="w-3.5 h-3.5" /> Falha: {contrato.ciclo?.motivoErroNF || "Erro desconhecido"}
                            </div>
                          )}

                          {(contrato.ciclo?.statusRepasse === "Aguardando Fechamento" || !contrato.ciclo?.statusRepasse) && (
                            <div className="flex items-center gap-1.5 text-slate-700 bg-slate-100 px-2.5 py-1 rounded-lg border border-slate-300 font-semibold text-xs w-max">
                              <Clock className="w-3.5 h-3.5" /> Bloqueado (Aguardando Fechamento)
                            </div>
                          )}

                          {contrato.ciclo?.statusRepasse === "Pago à Vista" && (
                            <div className="flex items-center gap-1.5 text-teal-700 bg-teal-50 px-2.5 py-1 rounded-lg border border-teal-200 font-semibold text-xs w-max">
                              <CheckCircle className="w-3.5 h-3.5" /> Pago à Vista (NF B2C)
                            </div>
                          )}

                          {contrato.ciclo?.statusRepasse === "Isolado - Pagamento Único" && (
                            <div className="flex items-center gap-1.5 text-blue-700 bg-blue-50 px-2.5 py-1 rounded-lg border border-blue-200 font-semibold text-xs w-max">
                              <CheckCircle className="w-3.5 h-3.5" /> Isolado (Pagamento Único)
                            </div>
                          )}

                          {contrato.ciclo?.statusRepasse === "Repasse Cobrado" && (
                            <div className="flex items-center gap-1.5 text-amber-700 bg-amber-50 px-2.5 py-1 rounded-lg border border-amber-200 font-semibold text-xs w-max">
                              <Receipt className="w-3.5 h-3.5" /> Bloqueado (Aguardando Pgto Imob)
                            </div>
                          )}
                          
                          {isEmitido && (
                            <div className="flex items-center gap-1.5 text-blue-700 bg-blue-50 px-2.5 py-1 rounded-lg border border-blue-200 font-semibold text-xs w-max">
                              <FileCheck className="w-3.5 h-3.5" /> NF Concluída
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* 🟢 PAGINAÇÃO DA TABELA DE LOCATÁRIOS */}
          {contratosDaEmpresa.length > 0 && (
            <div className="p-4 sm:p-5 border-t border-slate-200 bg-slate-50 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500 shrink-0">
              <span className="font-medium text-center sm:text-left">
                Mostrando <strong className="text-slate-800">{indexOfFirstLoc + 1}</strong> a <strong className="text-slate-800">{Math.min(indexOfLastLoc, contratosDaEmpresa.length)}</strong> de <strong className="text-slate-800">{contratosDaEmpresa.length}</strong> inquilinos
              </span>
              <div className="flex items-center gap-4 w-full sm:w-auto justify-center">
                <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
                  <span className="font-medium">Itens por página:</span>
                  <select 
                    value={itemsPerPageLoc}
                    onChange={(e) => setItemsPerPageLoc(Number(e.target.value))}
                    className="bg-transparent border-none font-bold text-brand-primary focus:ring-0 cursor-pointer text-sm outline-none"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
                {totalPagesLoc > 1 && (
                  <div className="flex items-center gap-2">
                    <button onClick={prevPageLoc} disabled={currentPageLoc === 1} className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 transition-colors shadow-sm">
                      <ChevronLeft className="w-4 h-4" />
                    </button>
                    <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                      {currentPageLoc} / {totalPagesLoc}
                    </span>
                    <button onClick={nextPageLoc} disabled={currentPageLoc >= totalPagesLoc} className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 transition-colors shadow-sm">
                      <ChevronRight className="w-4 h-4" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

    </div>
  );
};

export default AdminFaturamentoPage;